var _path, _path2, _rect, _path3, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobNetwrok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 12,
    viewBox: "0 0 64 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6543 1.85517C15.6543 1.34944 15.2728 0.939453 14.8022 0.939453H13.95C13.4794 0.939453 13.0978 1.34944 13.0978 1.85517V9.79143C13.0978 10.2972 13.4794 10.7071 13.95 10.7071H14.8022C15.2728 10.7071 15.6543 10.2972 15.6543 9.79143V1.85517ZM9.71521 2.89299H10.5674C11.038 2.89299 11.4195 3.31281 11.4195 3.83069V9.76945C11.4195 10.2873 11.038 10.7071 10.5674 10.7071H9.71521C9.24457 10.7071 8.86305 10.2873 8.86305 9.76945V3.83069C8.86305 3.31281 9.24457 2.89299 9.71521 2.89299ZM6.25455 5.00932H5.40239C4.93176 5.00932 4.55023 5.43449 4.55023 5.95896V9.7575C4.55023 10.282 4.93176 10.7071 5.40239 10.7071H6.25455C6.72519 10.7071 7.10671 10.282 7.10671 9.7575V5.95896C7.10671 5.43449 6.72519 5.00932 6.25455 5.00932ZM2.01975 6.96287H1.16759C0.696955 6.96287 0.31543 7.38196 0.31543 7.89894V9.77108C0.31543 10.2881 0.696955 10.7071 1.16759 10.7071H2.01975C2.49039 10.7071 2.87191 10.2881 2.87191 9.77108V7.89894C2.87191 7.38196 2.49039 6.96287 2.01975 6.96287Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8935 2.86875C30.8805 2.86884 32.7915 3.60549 34.2315 4.92646C34.3399 5.02844 34.5132 5.02715 34.62 4.92357L35.6566 3.91419C35.7107 3.86165 35.7408 3.79049 35.7404 3.71644C35.7399 3.6424 35.7089 3.57158 35.6542 3.51966C31.8746 0.0246964 25.9118 0.0246964 22.1322 3.51966C22.0775 3.57155 22.0464 3.64234 22.0459 3.71638C22.0454 3.79043 22.0755 3.86161 22.1295 3.91419L23.1664 4.92357C23.2731 5.02731 23.4466 5.0286 23.555 4.92646C24.9952 3.6054 26.9064 2.86875 28.8935 2.86875ZM28.8908 6.24034C29.9752 6.24027 31.0209 6.6491 31.8247 7.38738C31.9334 7.49216 32.1046 7.48989 32.2106 7.38227L33.239 6.32827C33.2932 6.27298 33.3232 6.19798 33.3224 6.12005C33.3217 6.04212 33.2901 5.96775 33.2349 5.9136C30.7872 3.6041 26.9966 3.6041 24.5489 5.9136C24.4936 5.96775 24.4621 6.04215 24.4613 6.12011C24.4606 6.19807 24.4908 6.27306 24.545 6.32827L25.5731 7.38227C25.6791 7.48989 25.8504 7.49216 25.9591 7.38738C26.7624 6.64959 27.8072 6.24079 28.8908 6.24034ZM30.9076 8.47211C30.9091 8.55627 30.8795 8.63741 30.8258 8.69638L29.0868 10.6575C29.0359 10.7151 28.9664 10.7475 28.8938 10.7475C28.8213 10.7475 28.7518 10.7151 28.7009 10.6575L26.9616 8.69638C26.9079 8.63737 26.8783 8.5562 26.8799 8.47204C26.8815 8.38787 26.9141 8.30817 26.97 8.25176C28.0806 7.20209 29.7071 7.20209 30.8176 8.25176C30.8735 8.30822 30.9061 8.38794 30.9076 8.47211Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.35,
    x: 42.5303,
    y: 1.03031,
    width: 19.1736,
    height: 9.58681,
    rx: 3.03582,
    stroke: "white",
    strokeWidth: 0.798901
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M62.9023 4.45117V7.70707C63.5452 7.43132 63.9633 6.78983 63.9633 6.07912C63.9633 5.36841 63.5452 4.72693 62.9023 4.45117",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 43.7295,
    y: 2.22852,
    width: 16.7769,
    height: 7.19011,
    rx: 1.99725,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobNetwrok);
export default __webpack_public_path__ + "static/media/mobNetwrok.9f9bfa767c5618d46f36eeb7c0b353a2.svg";
export { ForwardRef as ReactComponent };